import { Facility, FacilityCoreSlice } from './facility-core-types';
import { FacilitySliceCreator } from './facility-types';

export const createFacilityCoreSlice: FacilitySliceCreator<
  FacilityCoreSlice
> = (set) => ({
  facilities: [],
  selectedFacilityId: null,

  setFacilities: (facilities: Facility[]) =>
    set({
      facilities,
    }),

  selectFacility: (id: string | null) =>
    set({
      selectedFacilityId: id,
    }),

  clearFacilities: () =>
    set({
      facilities: [],
      selectedFacilityId: null,
    }),
});
